module.exports = __webpack_public_path__ + "static/media/design@2x.75f7a7a9.png";